import enviro from 'enviro';
import { useState } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useExperiments } from '../experiments';
import { SHORT_IDS_PRACTICE_MODE_PROD, SHORT_IDS_PRACTICE_MODE_QA } from './practiceModeConsts';
const isEnabledForShort = shortId => {
  if (!shortId) return false;
  if (enviro.isQa()) {
    return SHORT_IDS_PRACTICE_MODE_QA.includes(shortId);
  }
  return SHORT_IDS_PRACTICE_MODE_PROD.includes(shortId);
};
export const useIsPracticeModeEnabled = shortId => {
  var _experiments$acad;
  const [showPracticeModeOverlay, setShowPracticeModeOverlay] = useState(isEnabledForShort(shortId));
  const {
    isNotLaptop
  } = useMediaQuery();
  const {
    experiments
  } = useExperiments();
  const isPracticeModeExperimentEnabled = (experiments === null || experiments === void 0 || (_experiments$acad = experiments['acad-0034']) === null || _experiments$acad === void 0 || (_experiments$acad = _experiments$acad.parameters) === null || _experiments$acad === void 0 ? void 0 : _experiments$acad.group) === 'variation';
  return {
    isPracticeModeEnabled: isPracticeModeExperimentEnabled && isNotLaptop && showPracticeModeOverlay,
    setShowPracticeModeOverlay
  };
};